import { useEffect } from 'react';

/**
 * Custom hook to set the page title dynamically
 * @param title - The page-specific title
 * @param includeAppName - Whether to include "E-Unify" suffix (default: true)
 */
export const usePageTitle = (title: string, includeAppName: boolean = true) => {
  useEffect(() => {
    const previousTitle = document.title;
    
    if (includeAppName) {
      document.title = `${title} 🇺🇸 E-Unify`;
    } else {
      document.title = title;
    }
    
    console.log('🔍 Page title set to:', document.title);

    // Cleanup: restore previous title when component unmounts
    return () => {
      document.title = previousTitle;
    };
  }, [title, includeAppName]);
};

export default usePageTitle;
